import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import headersList from "Constants/headersList";
import moment from "moment";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { instance } from "../../../Actions/AxiosInstance";
import {
  SetAllApps,
  SetDrawerID,
  SetOpenLeftDrawer,
  SetSelection,
} from "../../../Actions/commonAction";
import PoliciesIcon from "../../../Assets/Icons/Policy/policy-16px.svg";
import DailyActivtiesIcon from "../../../Assets/Icons/to-do.svg";
import EmployeeProfileIcon from "../../../Assets/Icons/User/user-16px.svg";
import NotificationEmpty from "../../../Assets/Images/notification-center-empty.svg";
import RequestCenterIcon from "../../../Assets/newicons/app/request-center/outline/request-center-outline-16px.svg";

class NotificationCenter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      currentNotifications: [],
      yesterdayNotifications: [],
      thisWeeknotifications: [],
      newNotificationList: [],
      thismonthnotifications: [],
      allotherNotifications: [],
      ConstantsEntityid: [
        { name: "RequestCenter", key: 1, icon: RequestCenterIcon },
        { name: "Employee Profile", key: 2, icon: EmployeeProfileIcon },
        { name: "Policies", key: 3, icon: PoliciesIcon },
        { name: "Daily Activites", key: 4, icon: DailyActivtiesIcon },
      ],
      noNotifications: false,
    };
    this.expanded = this.expanded.bind(this);
    this.getallnotifications = this.getallnotifications.bind(this);
    this.sortPost = this.sortPost.bind(this);
  }

  componentDidMount() {
    this.getallnotifications();
    this.sortPost();
  }

  expanded() {
    this.setState({ expanded: true });
  }

  sortPost() {
    const today = moment().format("YYYY-MM-DD");
    const yesterday = moment().subtract(1, "day").format("YYYY-MM-DD");
    const currentNotifications = [];
    const yesterdayNotifications = [];
    const allotherNotifications = [];
    const thisWeeknotifications = [];
    const thismonthnotifications = [];
    console.log(this.state.newNotificationList);
    this.state.newNotificationList.map((item) => {
      if (moment(item.notifiedon).isSame(today, "day")) {
        currentNotifications.push(item);
      } else if (moment(item.notifiedon).isSame(yesterday)) {
        yesterdayNotifications.push(item);
      } else if (moment(item.notifiedon).week() == moment().week()) {
        thisWeeknotifications.push(item);
      } else if (moment(item.notifiedon).month() == moment().month()) {
        thismonthnotifications.push(item);
      } else {
        allotherNotifications.push(item);
      }
    });

    this.setState({
      currentNotifications,
      yesterdayNotifications,
      allotherNotifications,
      thisWeeknotifications,
      thismonthnotifications,
    });
  }

  getallnotifications() {
    const offset = 1;

    const limit = 50;

    const { employeeid } = this.props.AuthenticationAction.login;

    instance
      .get(`subscription/notificationlist/${offset}/${limit}/${employeeid}`)
      .then((result) => {
        this.setState({
          newNotificationList: result.data.result,
        });
        if (result.data.result.length > 0) {
          this.sortPost();
        } else {
          this.setState({ noNotifications: true });
        }
      })
      .catch((result) => result);
  }

  clearNotification() {
    this.setState({
      currentNotifications: [],
      yesterdayNotifications: [],
      newNotificationList: [],
      allotherNotifications: [],
    });
  }

  render() {
    return (
      <div className="content-outer-wrapper">
        <Helmet>
          <title>{headersList.NotificationCenter.header}</title>
        </Helmet>
        <Grid container className="notification-center-outer">
          <Grid item xs={12} md={12} sm={12}>
            <div>
              <span className="page-header-name">Notification Center</span>
            </div>
          </Grid>
          <Grid item xs={12} md={12} sm={12}>
            <Grid container>
              <Grid item xs={12} md={12} sm={12}>
                <Paper
                  className="notification-scroll padding24"
                  style={{
                    height: "70vh",
                    overflowY: "auto",
                    scrollBehavior: "smooth",
                  }}
                >
                  {/* //empty state */}
                  {this.state.newNotificationList.length == 0 ? (
                    <div
                      style={{
                        transform: "translateY(-50%)",
                        position: "relative",
                        top: "50%",
                      }}
                    >
                      <img
                        src={NotificationEmpty}
                        alt="No notification"
                        className="empty-notification-img"
                      />
                      <div
                        style={{
                          textAlign: "center",
                          fontSize: 22,
                          fontWeight: 700,
                          color: "#010709",
                          marginBottom: 8,
                          marginTop: 48,
                        }}
                      >
                        Nothing to show!
                      </div>
                      <div
                        style={{
                          textAlign: "center",
                          fontSize: 16,
                          fontWeight: 400,
                          color: "rgba(1,7,9,0.7)",
                        }}
                      >
                        You have not recieved any notifications. <br></br>Please
                        check back later.
                      </div>
                    </div>
                  ) : null}

                  {this.state.currentNotifications &&
                  this.state.currentNotifications.length > 0 ? (
                    <div>
                      <div>
                        <span className="notification-duration">Today</span>
                      </div>
                      <div className="notification-list">
                        {this.state.currentNotifications.map((item) => (
                          <ExpansionPanel
                            className="notification-expansion-panel"
                            expanded={false}
                            key="key"
                          >
                            <ExpansionPanelSummary
                              className="notification-expansion-panel-summary"
                              aria-controls="panel1bh-content"
                              id="panel1bh-header"
                            >
                              <Grid container className="padding-right-0">
                                <Grid item xs={12} md={9} sm={12}>
                                  {this.state.ConstantsEntityid.map((icons) => {
                                    if (icons.key == item.entityid) {
                                      return (
                                        <div className="notification-type-icon">
                                          <img src={icons.icon} />
                                        </div>
                                      );
                                    }
                                  })}
                                  <div>{item.message.body}</div>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  md={3}
                                  sm={12}
                                  className="text-align-right"
                                >
                                  <div>10.54</div>
                                </Grid>
                              </Grid>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                              {item.notifiedon && (
                                <div>
                                  {moment(item.notifiedon).format("L")} at
                                  {moment(item.notifiedon).format("LTS")}{" "}
                                </div>
                              )}
                            </ExpansionPanelDetails>
                          </ExpansionPanel>
                        ))}
                      </div>
                    </div>
                  ) : null}

                  {this.state.yesterdayNotifications &&
                  this.state.yesterdayNotifications.length > 0 ? (
                    <div style={{ marginTop: 20 }}>
                      <div>
                        <span className="notification-duration">Yesterday</span>
                      </div>
                      <div className="notification-list">
                        {this.state.yesterdayNotifications.map((item) => (
                          <ExpansionPanel
                            className="notification-expansion-panel"
                            expanded={false}
                            key="key"
                          >
                            <ExpansionPanelSummary
                              className="notification-expansion-panel-summary"
                              aria-controls="panel1bh-content"
                              id="panel1bh-header"
                            >
                              <Grid container className="padding-right-0">
                                <Grid item xs={12} md={9} sm={12}>
                                  {this.state.ConstantsEntityid.map((icons) => {
                                    if (icons.key == item.entityid) {
                                      return (
                                        <div className="notification-type-icon">
                                          <img src={icons.icon} />
                                        </div>
                                      );
                                    }
                                  })}
                                  <div>{item.message.body}</div>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  md={3}
                                  sm={12}
                                  className="text-align-right"
                                >
                                  {item.notifiedon && (
                                    <div>
                                      {moment(item.notifiedon).format("L")} at{" "}
                                      {moment(item.notifiedon).format("LTS")}
                                    </div>
                                  )}
                                </Grid>
                              </Grid>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                              <div>Date: 23 June 2019 - 26 June 2019</div>
                            </ExpansionPanelDetails>
                          </ExpansionPanel>
                        ))}
                      </div>
                    </div>
                  ) : null}

                  {this.state.thisWeeknotifications &&
                    this.state.thisWeeknotifications.length > 0 && (
                      <div style={{ marginTop: 20 }}>
                        <div>
                          <span className="notification-duration">
                            This Week
                          </span>
                        </div>
                        <div className="notification-list">
                          {this.state.thisWeeknotifications.map((item) => (
                            <ExpansionPanel
                              className="notification-expansion-panel"
                              expanded={false}
                              key="key"
                            >
                              <ExpansionPanelSummary
                                className="notification-expansion-panel-summary"
                                aria-controls="panel1bh-content"
                                id="panel1bh-header"
                              >
                                <Grid container className="padding-right-0">
                                  <Grid item xs={12} md={9} sm={12}>
                                    {this.state.ConstantsEntityid.map(
                                      (icons) => {
                                        if (icons.key == item.entityid) {
                                          return (
                                            <div className="notification-type-icon">
                                              <img src={icons.icon} />
                                            </div>
                                          );
                                        }
                                      },
                                    )}
                                    <div>{item.message.body}</div>
                                  </Grid>
                                  <Grid
                                    item
                                    xs={12}
                                    md={3}
                                    sm={12}
                                    className="text-align-right"
                                  >
                                    {item.notifiedon && (
                                      <div>
                                        {moment(item.notifiedon).format("L")} at{" "}
                                        {moment(item.notifiedon).format("LTS")}
                                      </div>
                                    )}
                                  </Grid>
                                </Grid>
                              </ExpansionPanelSummary>
                              <ExpansionPanelDetails>
                                <div>Date: 23 June 2019 - 26 June 2019</div>
                              </ExpansionPanelDetails>
                            </ExpansionPanel>
                          ))}
                        </div>
                      </div>
                    )}
                  {this.state.thismonthnotifications &&
                    this.state.thismonthnotifications.length > 0 && (
                      <div style={{ marginTop: 20 }}>
                        <div>
                          <span className="notification-duration">
                            This Month
                          </span>
                        </div>
                        <div className="notification-list">
                          {this.state.thismonthnotifications.map((item) => (
                            <ExpansionPanel
                              className="notification-expansion-panel"
                              expanded={false}
                              key="key"
                            >
                              <ExpansionPanelSummary
                                className="notification-expansion-panel-summary"
                                aria-controls="panel1bh-content"
                                id="panel1bh-header"
                              >
                                <Grid container className="padding-right-0">
                                  <Grid item xs={12} md={9} sm={12}>
                                    {this.state.ConstantsEntityid.map(
                                      (icons) => {
                                        if (icons.key == item.entityid) {
                                          return (
                                            <div className="notification-type-icon">
                                              <img src={icons.icon} />
                                            </div>
                                          );
                                        }
                                      },
                                    )}
                                    <div>{item.message.body}</div>
                                  </Grid>
                                  <Grid
                                    item
                                    xs={12}
                                    md={3}
                                    sm={12}
                                    className="text-align-right"
                                  >
                                    {item.notifiedon && (
                                      <div
                                        style={{ color: "rgba(1,7,9,0.35)" }}
                                      >
                                        {moment(item.notifiedon).format("L")} at{" "}
                                        {moment(item.notifiedon).format("LTS")}
                                      </div>
                                    )}
                                  </Grid>
                                </Grid>
                              </ExpansionPanelSummary>
                              <ExpansionPanelDetails>
                                <div>Date: 23 June 2019 - 26 June 2019</div>
                              </ExpansionPanelDetails>
                            </ExpansionPanel>
                          ))}
                        </div>
                      </div>
                    )}

                  {this.state.allotherNotifications &&
                    this.state.allotherNotifications.length > 0 && (
                      <div>
                        <div>
                          <span className="notification-duration">
                            Previous
                          </span>
                        </div>
                        <div className="notification-list">
                          {this.state.allotherNotifications &&
                            this.state.allotherNotifications.map((item) => (
                              <ExpansionPanel
                                className="notification-expansion-panel"
                                expanded={false}
                                key="key"
                              >
                                <ExpansionPanelSummary
                                  className="notification-expansion-panel-summary"
                                  aria-controls="panel1bh-content"
                                  id="panel1bh-header"
                                >
                                  <Grid container className="padding-right-0">
                                    <Grid item xs={12} md={9} sm={12}>
                                      {this.state.ConstantsEntityid.map(
                                        (icons) => {
                                          if (icons.key == item.entityid) {
                                            return (
                                              <div className="notification-type-icon">
                                                <img src={icons.icon} />
                                              </div>
                                            );
                                          }
                                        },
                                      )}
                                      <div>
                                        {item.message != null
                                          ? item.message.body
                                          : ""}
                                      </div>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      md={3}
                                      sm={12}
                                      className="text-align-right"
                                    >
                                      {item.notifiedon && (
                                        <div>
                                          {moment(item.notifiedon).format("L")}{" "}
                                          at{" "}
                                          {moment(item.notifiedon).format(
                                            "LTS",
                                          )}
                                        </div>
                                      )}
                                    </Grid>
                                  </Grid>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails>
                                  <div>Date: 23 June 2019 - 26 June 2019</div>
                                </ExpansionPanelDetails>
                              </ExpansionPanel>
                            ))}
                        </div>
                      </div>
                    )}

                  {/* <ExpansionPanel className="notification-expansion-panel">
                      <ExpansionPanelSummary
                        // className="notification-expansion-panel-summary"
                        className={classNames(classes.expanded, 'notification-expansion-panel-summary')}
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                      >
                        <Grid container className="padding-right-0">
                        <Grid item xs={12} md={10} sm={12}>
                          <div className="notification-type-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                              <path fill="#D9DADB" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm.808 3.333l-.133 6h-1.35l-.133-6h1.616zm-.806 9.46c-.552 0-.882-.294-.882-.788 0-.504.33-.798.882-.798.548 0 .877.294.877.798 0 .494-.329.788-.877.788z"/>
                            </svg>
                          </div>
                          <div>
                            Kushalraj Pandey has accepted your leave request.
                          </div>
                        </Grid>
                        <Grid item xs={12} md={2} sm={12} className="text-align-right">
                          <div>
                            10.54
                          </div>
                        </Grid>
                      </Grid>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails className="notification-expansionpanel-details" style={{flexDirection:"column"}}>
                        <div>
                          <span style={{marginBottom:8, display:"block"}}>
                            Date: 23 June 2019 - 26 June 2019
                          </span>
                        </div>
                        <div>
                          <span style={{marginBottom:8, display:"block"}}>
                            Remarks: Please be available on call at all times.
                          </span>
                        </div>
                        <div className="margin-left-16 floatleft">
                          <span className="notification-authority">
                            <img src={CheckImg} alt="icon" className="notification-authority-thumbnail"/>
                          </span>
                          <span style={{float:"left", marginTop:4, marginLeft:4}}>1 of 3 approvals received</span>
                          <div className="floatright">
                            <Tooltip title="Go to Request Center" placement="left">
                              <button className="arrow-btn">
                                <img style={{height:12,width:12,verticalAlign:"middle",}} src={rightArrow}></img>
                              </button>
                            </Tooltip>
                          </div>
                        </div>

                      </ExpansionPanelDetails>
                    </ExpansionPanel> */}
                </Paper>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  AuthenticationAction: state.AuthenticationAction,
  SubscriptionInfo: state.SubscriptionInfo,
  selectionReducer: state.selectionReducer,
  FCMReducer: state.FCMReducer,
  SetOpenLeftDrawer: state.selectionReducer.openLeftDrawer,
  isallappsopen: state.selectionReducer.isallappsopen,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      SetOpenLeftDrawer: (type, payload) => SetOpenLeftDrawer(type, payload),
      SetAllApps,
      SetSelection: (d) => SetSelection(d),
      SetDrawerID: (dt) => SetDrawerID(dt),
    },
    dispatch,
  );
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withSnackbar(NotificationCenter)),
);
